import { AnyAction } from 'redux';
import { GlobalAction, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { EinstiegResponse } from '@ps20/bff-models';
import get from 'lodash/get';
import { convertDate } from '@ps20-frontend/utils';
import { determineAssekuranztarifFromTarifbereich } from '@ps20-frontend/frontend-models';
import { Versicherungsnehmer, VnRoleEnum } from '../interfaces/versicherungsnehmer';
import { ToolbarActions } from '../toolbar.actions';

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
): Versicherungsnehmer {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const einstiegResponseGlobalAction: GlobalAction<EinstiegResponse> = action;
      const vn: Versicherungsnehmer = get(
        einstiegResponseGlobalAction,
        'payload.versicherungsnehmer',
        null,
      );

      if (!vn) {
        return sectionState;
      }

      return {
        ...vn,
        geburtsdatum: vn.geburtsdatum ? convertDate(vn.geburtsdatum) : null,
        currentRole: VnRoleEnum.KEIN,
      };
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA:
    case GlobalActions.ASSEKURANZTARIF_CHANGED_VORVERTRAG: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
        currentRole: sectionState.selectedRole || sectionState.currentRole,
      };
    }
    case ToolbarActions.UPDATE_CURRENT_VN_ROLE: {
      return {
        ...sectionState,
        currentRole: action.payload,
      };
    }
    case ToolbarActions.UPDATE_VORBELEGTE_VN_ROLE: {
      return {
        ...sectionState,
        vorbelegteRole: action.payload,
      };
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    case ToolbarActions.VN_ROLE_SELECTION_CHANGED: {
      return {
        ...sectionState,
        selectedRole: action.payload,
      };
    }
    default:
      return sectionState;
  }
};
